import { configureStore } from '@reduxjs/toolkit'

import authData from 'model/reducers/authData'
import courses from 'model/reducers/courses'
import frees from 'model/reducers/frees'
import webinars from 'model/reducers/webinars'
import conferences from 'model/reducers/conferences'
import userPayments from 'model/reducers/userPayments'
import admins from 'model/reducers/admins'
import notificationsSettings from 'model/reducers/notificationsSettings'
import library from 'model/reducers/library'
import partitions from 'model/reducers/partitions'
import levels from 'model/reducers/levels'
import teachers from 'model/reducers/teachers'
import seminars from 'model/reducers/seminars'
import channels from 'model/reducers/channels'
import user from 'model/reducers/user'
import coursesPacks from 'model/reducers/coursesPacks'
import paymentLinks from 'model/reducers/paymentLinks'
import languages from 'model/reducers/languages'
import cardTags from 'model/reducers/cardTags'
import wordCards from 'model/reducers/wordCards'
import fileTree from 'model/reducers/fileTree'

const store = configureStore({
  reducer: {
    authData,
    courses,
    webinars,
    userPayments,
    conferences,
    admins,
    notificationsSettings,
    library,
    partitions,
    levels,
    teachers,
    seminars,
    channels,
    user,
    frees,
    coursesPacks,
    paymentLinks,
    languages,
    cardTags,
    wordCards,
    fileTree
  }
})
export default store
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
